import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

console.log('debug', debug)

export default new Vuex.Store({
  strict: debug,
  state: {
    user: null,
    showAlert: false,
    alertMessage: 'Default Message',
  },
  mutations: {
    setAlert (state, message) {
      state.alertMessage = message
      state.showAlert = true
    },
    dismissAlert (state) {
      state.alertMessage = 'Default Message'
      state.showAlert = false
    },
    setUser (state, user) {
      state.user = user
    }
  },
  actions: {
  },
  modules: {
  }
})
